import { render, staticRenderFns } from "./LeftWrap2.vue?vue&type=template&id=2d938d2c&scoped=true"
import script from "./LeftWrap2.vue?vue&type=script&lang=js"
export * from "./LeftWrap2.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap2.vue?vue&type=style&index=0&id=2d938d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d938d2c",
  null
  
)

export default component.exports